
const digest = '94e8ac8730de50d67ab5ed1d5d8abed78fdba68c9bf5c71b7a8410a9d96acd7e';
const css = `._content_bejpi_1 {
  width: 350px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

._dialog_bejpi_9 {
  padding: 64px;
}

._connectButton_bejpi_13 {
  margin-bottom: 12px !important;
  width: 100%;
}

._title_bejpi_18 {
  margin-top: 15px !important;
  text-align: center;
}

@media only screen and (max-width: 540px) {
  ._content_bejpi_1 {
    width: 100%;
  }
}`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"content":"_content_bejpi_1","dialog":"_dialog_bejpi_9","connectButton":"_connectButton_bejpi_13","title":"_title_bejpi_18"};
export { css, digest };
  